var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('router-link', {
    staticClass: "s-flex s-items-center s-py-5",
    attrs: {
      "to": {
        name: 'LiffMemberCardTransactionsShow',
        params: {
          id: _vm.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "s-mr-auto"
  }, [_c('p', {
    staticClass: "s-font-semibold s-text-gray-darker s-text-lg"
  }, [_vm._v(_vm._s(_vm.transaction.branch.name))]), _c('time', {
    staticClass: "s-text-gray-dark s-text-xs"
  }, [_vm._v(_vm._s(_vm.time))])]), _c('div', {
    staticClass: "s-text-secondary s-font-semibold s-mr-3"
  }, [_c('span', {
    staticClass: "s-text-sm"
  }, [_vm._v("NT$ ")]), _c('span', {
    staticClass: "s-text-xl"
  }, [_vm._v(_vm._s(_vm.transaction.total))])]), _c('div', {
    staticClass: "s-text-gray s-font-lg"
  }, [_vm._v(">")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }